import { render, staticRenderFns } from "./siteFence.vue?vue&type=template&id=589f843d&scoped=true&"
import script from "./siteFence.vue?vue&type=script&lang=js&"
export * from "./siteFence.vue?vue&type=script&lang=js&"
import style0 from "./siteFence.vue?vue&type=style&index=0&id=589f843d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589f843d",
  null
  
)

export default component.exports